import MassActionBar from './MassActionBar';

export default MassActionBar;
